const channels = {
  development: {
    label: 'Development',
    className: 'border-sky-400/40 bg-sky-500/20 text-sky-100',
    dotClassName: 'bg-sky-300',
  },
  beta: {
    label: 'Beta',
    className: 'border-amber-400/40 bg-amber-500/20 text-amber-100',
    dotClassName: 'bg-amber-300',
  },
} as const;

export function EnvironmentBanner() {
  const channel = import.meta.env.VITE_RELEASE_CHANNEL?.toLowerCase();
  const presentation = channel === 'development' || channel === 'beta' ? channels[channel] : null;

  if (!presentation) return null;

  return (
    <div
      role="status"
      aria-label={`${presentation.label} environment`}
      className={`fixed left-1/2 top-0 z-[100] flex -translate-x-1/2 items-center gap-2 rounded-b-lg border border-t-0 px-4 py-1 text-xs font-semibold uppercase tracking-[0.16em] shadow-lg backdrop-blur-md ${presentation.className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${presentation.dotClassName}`} aria-hidden="true" />
      {presentation.label}
    </div>
  );
}

export default EnvironmentBanner;
